import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiFile, FiEdit, FiList, FiFileText, FiAlertCircle } from 'react-icons/fi';

const Report = () => {
    const navigate = useNavigate();

    const reportCards = [
        // Row 1
        {
            id: 'namuna-8-personal',
            title: 'नमुना नं. ८ व्यक्तिगत',
            icon: <FiFile className="w-8 h-8" />,
            description: 'वैयक्तिक माहितीचा अहवाल',
            path: '/reportnamuna8v',
            color: 'from-blue-500 to-cyan-500'
        },
        {
            id: 'namuna-8-register',
            title: 'नमुना नं. ८ रजिस्टर',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'रजिस्टर अहवाल',
            path: '/namuna8-register',
            color: 'from-emerald-500 to-teal-500'
        },
        {
            id: 'namuna-9',
            title: 'नमुना नं. ९',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'नमुना ९ अहवाल',
            path: '/namuna9',
            color: 'from-orange-500 to-amber-500'
        },
        {
            id: 'namuna-9k',
            title: 'नमुना नं. ९ क',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'नमुना ९ क अहवाल',
            path: '/namuna9k',
            color: 'from-purple-500 to-indigo-500'
        },
        {
            id: 'namuna-10',
            title: 'नमुना नं. १०',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'नमुना १० अहवाल',
            path: '/namuna10',
            color: 'from-rose-500 to-pink-500'
        },
        {
            id: 'tax-collection-ledger',
            title: 'कर वसुलीची पोटकिर्द',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'कर वसुली पोटकिर्द अहवाल',
            path: '/tax-collection-ledger',
            color: 'from-gray-700 to-gray-900'
        },
        // Row 2
        {
            id: 'tax-bill',
            title: 'कर बिल',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'कर बिल अहवाल',
            path: '/tax-bill',
            color: 'from-blue-600 to-indigo-600'
        },
        {
            id: 'tax-notice',
            title: 'कर नोटीस',
            icon: <FiEdit className="w-8 h-8" />,
            description: 'कर नोटीस अहवाल',
            path: '/tax-notice',
            color: 'from-teal-500 to-emerald-500'
        },
        {
            id: 'defaulters-list',
            title: 'थकबाकीदार यादी',
            icon: <FiAlertCircle className="w-8 h-8" />,
            description: 'थकबाकीदारांची यादी',
            path: '/defaulters-list',
            color: 'from-emerald-500 to-green-500'
        },
        {
            id: 'property-change-register',
            title: 'मिळकत फेरबदल रजिस्टर',
            icon: <FiList className="w-8 h-8" />,
            description: 'मिळकत फेरबदल रजिस्टर',
            path: '/property-change-register',
            color: 'from-amber-500 to-orange-500'
        },
        {
            id: 'gram-nidhi-info',
            title: 'ग्रामनिधी माहिती सुविधा',
            icon: <FiList className="w-8 h-8" />,
            description: 'ग्रामनिधी माहिती सुविधा',
            path: '/gram-nidhi-info',
            color: 'from-cyan-500 to-blue-500'
        },
        {
            id: 'monthly-tax-collection',
            title: 'मासिक कर वसुली अहवाल',
            icon: <FiFileText className="w-8 h-8" />,
            description: 'मासिक कर वसुलीचा अहवाल',
            path: '/monthly-tax-collection',
            color: 'from-indigo-500 to-purple-500'
        }
    ];

    const handleCardClick = (path) => {
        if (path !== '#') {
            navigate(path);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 p-6">
            {/* Header */}
            <div className="max-w-7xl mx-auto mb-10">
                <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 flex flex-col md:flex-row justify-between items-center bg-gradient-to-r from-slate-800 to-slate-900 text-white">
                    <div>
                        <h1 className="text-3xl font-bold mb-2">अहवाल</h1>
                        <p className="text-slate-300">
                            ग्रामपंचायत | आर्थिक वर्ष: २०२४-२५
                        </p>
                    </div>
                    <button
                        onClick={() => navigate(-1)}
                        className="mt-4 md:mt-0 px-6 py-2 bg-white/10 hover:bg-white/20 rounded-lg transition-colors duration-200 text-sm font-medium backdrop-blur-sm flex items-center gap-2"
                    >
                        <FiArrowLeft size={16} />
                        मागे जा
                    </button>
                </div>
            </div>

            {/* Cards Grid - 3 columns */}
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {reportCards.map((card) => (
                    <div
                        key={card.id}
                        onClick={() => handleCardClick(card.path)}
                        className="group cursor-pointer bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden border border-gray-100"
                    >
                        <div className={`h-2 bg-gradient-to-r ${card.color}`}></div>
                        <div className="p-6">
                            <div
                                className={`w-16 h-16 rounded-xl bg-gradient-to-br ${card.color} flex items-center justify-center text-white mb-4 shadow-lg group-hover:scale-110 transition-transform duration-300`}
                            >
                                {card.icon}
                            </div>
                            <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">
                                {card.title}
                            </h3>
                            <p className="text-gray-500 text-sm">{card.description}</p>
                        </div>
                        <div className="px-6 py-4 bg-gray-50 border-t border-gray-100 flex justify-between items-center">
                            <span className="text-sm font-medium text-gray-600 group-hover:text-blue-600 transition-colors">
                                निवडा
                            </span>
                            <svg
                                className="w-5 h-5 text-gray-400 group-hover:text-blue-600 transform group-hover:translate-x-1 transition-all duration-300"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                                />
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Report;